import React from 'react';
import '../../styles/components.css';

const ErrorMessage = ({ message, onRetry, type = 'error' }) => {
  const typeClass = {
    error: 'alert-danger',
    warning: 'alert-warning',
    info: 'alert-info'
  }[type];

  return (
    <div className={`alert ${typeClass} error-message`} role="alert">
      <div className="error-content">
        <span className="error-icon">
          {type === 'error' && '⚠️'}
          {type === 'warning' && '⚡'}
          {type === 'info' && 'ℹ️'}
        </span>
        <span className="error-text">{message}</span>
      </div>
      {onRetry && (
        <button 
          className="btn btn-sm btn-outline-danger mt-2" 
          onClick={onRetry}
        >
          Reintentar
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;

// Made with Bob
